import { Directive } from '@angular/core';

@Directive({
  selector: '[appFieldsetAccordion]',
})
export class FieldsetAccordionDirective { }
